
import React from 'react';
import { MessageSquare, BarChart3, Users, Clock, ArrowRight } from 'lucide-react';
import Button from '@/components/ui/Button';
import StoreButton from '@/components/ui/StoreButton';
import { COMPANY_INFO } from '@/lib/constants';

const DownloadSection = () => {
  return (
    <section className="relative py-20 sm:py-24 md:py-32 bg-white overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Floating icons */}
        <div className="absolute top-[15%] left-[10%] animate-float">
          <div className="w-14 h-14 bg-orcsys-50 rounded-xl flex items-center justify-center shadow-lg">
            <MessageSquare className="w-7 h-7 text-orcsys-400" />
          </div>
        </div>
        <div className="absolute top-[25%] right-[15%] animate-float-delayed">
          <div className="w-14 h-14 bg-orcsys-50 rounded-xl flex items-center justify-center shadow-lg">
            <BarChart3 className="w-7 h-7 text-orcsys-400" />
          </div>
        </div>
        <div className="absolute bottom-[25%] left-[15%] animate-float-more-delayed">
          <div className="w-14 h-14 bg-orcsys-50 rounded-xl flex items-center justify-center shadow-lg">
            <Users className="w-7 h-7 text-orcsys-400" />
          </div>
        </div>
        <div className="absolute bottom-[15%] right-[10%] animate-float-most-delayed">
          <div className="w-14 h-14 bg-orcsys-50 rounded-xl flex items-center justify-center shadow-lg">
            <Clock className="w-7 h-7 text-orcsys-400" />
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          <div className="text-left space-y-8 md:space-y-10">
            <div className="space-y-6">
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 leading-tight">
                Télécharger Collab
              </h2>
              <p className="text-xl sm:text-2xl text-slate-600 leading-relaxed max-w-2xl">
                Collab est gratuit pour les clients Orcsys. Rejoignez-nous dès maintenant dans l'aventure.
              </p>
            </div>
            
            <div className="flex flex-row items-center md:items-start justify-center md:justify-start gap-4">
              <StoreButton type="apple" url={COMPANY_INFO.collab.apple} />
              <StoreButton type="google" url={COMPANY_INFO.collab.google} />
            </div>
          </div>

          {/* Phone Mockup - Hidden on mobile */}
          <div className="relative flex justify-center lg:justify-start">
            <div className="relative w-44 h-88 sm:w-56 sm:h-[448px] md:w-64 md:h-[512px] transform hover:scale-105 transition-transform duration-300">
              <div className="absolute inset-0 bg-gradient-to-r from-orcsys-100 to-orcsys-200 rounded-[2rem] blur-xl opacity-50 animate-pulse-soft"></div>
              <div className="relative bg-white rounded-[2rem] shadow-xl overflow-hidden border border-gray-100">
                {/* Phone Notch */}
                <div className="h-4 sm:h-5 md:h-6 bg-slate-900 rounded-t-[2rem] flex items-center justify-center">
                  <div className="w-14 sm:w-18 md:w-22 h-3 sm:h-4 md:h-5 bg-slate-800 rounded-full"></div>
                </div>
                {/* Phone Screen */}
                <div className="aspect-[9/17] bg-gradient-to-br from-orcsys-50 to-white overflow-hidden">
                  <img 
                    src="images/collab-mobile.png" 
                    alt="Collab mobile interface"
                    className="w-full h-full object-cover"
                  />
                </div>
                {/* Phone Home Button */}
                <div className="h-8 sm:h-10 md:h-12 bg-slate-100 border-t border-gray-200 flex items-center justify-center">
                  <div className="w-8 sm:w-10 md:w-12 h-1.5 bg-slate-300 rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
